import documentTypeTemplate from "./documentTypeTemplate";

export default [
  { id: documentTypeTemplate.AR_INVOICE, name: "AR Invoice" },
  { id: documentTypeTemplate.W9, name: "W9" },
  { id: documentTypeTemplate.DIVISION_ORDER, name: "Division Order" },
  { id: documentTypeTemplate.PENDING_DIVISION_ORDER, name: "Pending Division Order" },
  { id: documentTypeTemplate.ACH, name: "ACH Form" },
  { id: documentTypeTemplate.RUN_STATEMENT, name: "Run Statement" },
  { id: documentTypeTemplate.OWNER_STATEMENT, name: "Owner Statement" },
  { id: documentTypeTemplate.DOCUMENT_1099, name: "1099", isAdminOnly: true },
];
